import { render, staticRenderFns } from "./FieldPrinter.vue?vue&type=template&id=4b872f5c&scoped=true&"
import script from "./FieldPrinter.vue?vue&type=script&lang=js&"
export * from "./FieldPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b872f5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
